/**
 * Normaliza URL para parseo (añade https:// si falta el esquema).
 * @param {string|null|undefined} raw
 * @returns {string}
 */
export function normalizeHttpsUrl(raw) {
  const t = String(raw ?? '').trim();
  if (!t) return '';
  if (/^https?:\/\//i.test(t)) return t;
  return `https://${t.replace(/^\/+/, '')}`;
}

/**
 * Vacío = válido (campo opcional). Si hay texto, debe ser un enlace de ubicación de Google Maps.
 * Acepta dominios habituales (google.com/maps, maps.google.com, maps.app.goo.gl, goo.gl/maps/…).
 * @param {string|null|undefined} raw
 * @returns {boolean}
 */
export function isGoogleMapsLocationUrl(raw) {
  const t = String(raw ?? '').trim();
  if (!t) return true;
  let u;
  try {
    u = new URL(normalizeHttpsUrl(t));
  } catch {
    return false;
  }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
  const host = u.hostname.toLowerCase();
  const path = u.pathname.toLowerCase();
  if (host === 'maps.app.goo.gl') return true;
  if (host === 'goo.gl' && path.startsWith('/maps')) return true;
  if (host === 'g.co' && path.startsWith('/maps')) return true;
  if (host === 'maps.google.com') return true;
  if (host === 'www.google.com' || host === 'google.com') return path.startsWith('/maps') || path.includes('/maps/');
  if (host === 'www.google.es' || host === 'google.es') return path.startsWith('/maps') || path.includes('/maps/');
  if (host.startsWith('www.google.') && path.startsWith('/maps')) return true;
  return false;
}
